import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { apiConnector } from '@/integrations/api.connector';
import { keysToCamelCase } from '@/services';

import {
  type SystemNotificationResponse,
  type TNotificationServerResponse
} from '../types/notifications';
import { type TNotificationsStore } from '../types/store';
import { createAsyncThunk } from './create-async-thunk';

export const startNotification = createAsyncThunk(
  'admin/system-notifications',
  async () => {
    const res = await apiConnector.startNotification();
    return res?.payload;
  }
);

const initialState: TNotificationsStore = {
  notifications: [],
  systemNotifications: [],
  lastNotificationsChecked: true,
  showNotifications: false
};

export const notificationsSlice = createSlice({
  name: 'notificationsSlice',
  initialState,
  reducers: {
    onToggleShowNotifications: (state) => {
      state.showNotifications = !state.showNotifications;
      if (state.showNotifications) state.lastNotificationsChecked = true;
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    addNewNotification: (
      state,
      action: PayloadAction<TNotificationServerResponse>
    ) => {
      state.lastNotificationsChecked = false;
      state.notifications = [action.payload, ...state.notifications];
    },
    setSystemNotifications: (
      state,
      action: PayloadAction<SystemNotificationResponse[]>
    ) => {
      state.systemNotifications = keysToCamelCase(
        action.payload.filter((item) => item.is_active)
      );
    }
  },
  extraReducers: (builder) => {
    builder.addCase(startNotification.fulfilled, (state, action) => {
      state.systemNotifications = action.payload
        ? keysToCamelCase(action.payload)
        : state.systemNotifications;
    });
  }
});

export const {
  onToggleShowNotifications,
  clearNotifications,
  addNewNotification,
  setSystemNotifications
} = notificationsSlice.actions;
